import { Component, OnInit, Input } from '@angular/core';
import { Tip } from '../../shared/domain/tip';
import { SessionService } from '../../shared/services/session/session.service';

@Component({
  selector: 'vit-tip-selection',
  templateUrl: './tip-selection.component.html',
  styleUrls: ['./tip-selection.component.scss']
})
export class TipSelectionComponent implements OnInit {

  @Input() tickets: Tip[] = [];

  constructor(public sessionService: SessionService) {
  }

  ngOnInit() {
  }

  right() {
    let idx: number = this.tickets.indexOf(this.sessionService.selectedTip);
    if (this.sessionService.tickets.length - 1 === idx) {
      this.sessionService.selectedTipIndex = 0;
    } else {
      this.sessionService.selectedTipIndex = idx + 1;
    }
  }

  left() {
    let idx: number = this.tickets.indexOf(this.sessionService.selectedTip);
    if (idx === 0) {
      this.sessionService.selectedTipIndex = this.sessionService.tickets.length - 1;
    } else {
      this.sessionService.selectedTipIndex = idx - 1;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/game-view/tip-selection/tip-selection.component.ts